import Papa from 'papaparse';

type BarcodeObj = { barcode: string };

function parseCsvCells(input: string): string[] {
  const result = Papa.parse<string[]>(input, {
    delimiter: ',',
    header: false,
    skipEmptyLines: 'greedy',
    dynamicTyping: false,
  });

  const cells: string[] = [];
  for (const row of result.data as unknown as (string | number | boolean | null)[][]) {
    for (const cell of row) {
      const s = String(cell ?? '').trim();
      if (s) cells.push(s);
    }
  }
  return cells;
}

export const handleSeparatingPackages = (
  data: string | null | undefined,
): BarcodeObj[] => {
  if (!data) return [];

  const cells = parseCsvCells(data);
  if (cells.length === 0) return [];

  return cells
    .map((s) => s.trim())
    .filter(Boolean)
    .map((barcode) => ({ barcode }));
};
